import { createRequestTypes } from "../../utils";


// FETCH BANNERS
export const FETCH_BANNERS = createRequestTypes("FETCH_BANNERS");

export const fetchBannersRequest = () =>
    ({ type: FETCH_BANNERS.REQUEST });
export const fetchBannersSuccess = (payload) =>
    ({ type: FETCH_BANNERS.SUCCESS, payload });
export const fetchBannersFailure = (error) =>
    ({ type: FETCH_BANNERS.FAILURE, payload: { error } });
